import ScreeningCardable from './screening-cardable';
import attr from 'ember-data/attr';
import { hasMany } from 'miragejs';

export default ScreeningCardable.extend({
  userData: hasMany('graphql/user-data'),

  capacityReached: attr('boolean'),
  fullName: attr('string'),
  email: attr('string'),
  expectedArrivalTime: attr('date'),
  locationId: attr('boolean'),
});
